/* Sofia's Spot - cart drawer offers, build cart-v2 (30 Sep 2026; cart-v1 25 Sep 2026).
   Pairs with snippets/sofia-cart-offers.liquid, which picks the offers server-side on every drawer render.
   - Add: one tap adds the piece with its hidden stamps (_bundle_anchor, _bundle_row, _bundle_surface=cart,
     _bundle_build = the build the snippet printed, cart-v2) through the shared cart queue (window.sofiaCartQueue, the
     gift box's), then refreshes with the theme's own Shopify.theme.ajaxCart.updateView so x, +/- and quantity keep
     working. The drawer stays open. A failed add re-reads the cart before the button comes back, so a piece is never
     added twice.
   - Pixel (custom pixel forwards these to the warehouse), all with surface 'cart' and arm 'cart' so none of it counts
     toward the gift box test:
       sofia_bundle_view    once per page load per distinct offer set, while the offers are on screen
       sofia_bundle_add     on every add from the drawer
       sofia_bundle_remove  when a drawer-added line is removed with x or taken to 0 (read in the capture phase from the
                            stamped-lines list the snippet prints; the theme's own handler is never blocked)
       sofia_drawer_state   (30 Sep 2026, board row 421 d) once per page load per distinct drawer state, while the drawer
                            (or the cart page) is on screen: what the message above the offers said (its kind and our own
                            words), the gap to the free-shipping line, and the offers shown with their row and price.
                            Cart and offer numbers only - nothing about the shopper.
   - Link markers (30 Sep 2026, board row 421 a): a tap on a link in the drawer, the menu, a gift box tile or the footer
     adds _src=drawer|menu|giftbox|giftbox_piece|footer to that link as it is followed, so the warehouse can tell where a
     page was reached from (the page address carries it). Links are only changed at the moment of the tap, never in the
     page itself, and any other part of the address (the colour circle's _sw, a spare box's set/box) is kept.
   The card row's Choose button belongs to sofia-gift.js (data-sg-open with data-sg-stamp). */
(function () {
  if (window.__sofiaCartOffers) return; window.__sofiaCartOffers = true;
  var BUILD = 'cart-v2';
  var Q = window.sofiaCartQueue = window.sofiaCartQueue || (function () {
    var tail = Promise.resolve();
    return function (task) { var run = tail.then(task, task); tail = run.catch(function () {}); return run; };
  })();

  function pub(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
  }
  function cfg() {
    var el = document.getElementById('cart-config');
    try { return JSON.parse((el && el.textContent) || '{}'); } catch (e) { return {}; }
  }
  function drawer() { return document.getElementById('slideout-ajax-cart'); }
  function isOpen(d) {
    if (!d) return false;
    try { return d.matches(':popover-open'); } catch (e) { return false; }
  }
  function theme() {
    var T = window.Shopify && Shopify.theme;
    return (T && T.cart && T.cart.getCart && T.ajaxCart && T.ajaxCart.updateView) ? T : null;
  }
  function buildOf(el) {
    var box = el && el.closest && el.closest('[data-sco]');
    return (box && box.getAttribute('data-sco-build')) || BUILD;
  }
  function readCart() {
    return Q(function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
    });
  }
  /* The theme's own refresh: re-renders every cart container, re-binds x, +/- and quantity, re-inits the wallet buttons. */
  function redraw(keepOpen) {
    var T = theme();
    if (!T) return Promise.resolve();
    return readCart().then(function (cart) {
      var c = cfg();
      T.ajaxCart.updateView(c, cart);
      if (keepOpen && !isOpen(drawer()) && T.ajaxCart.showDrawer) T.ajaxCart.showDrawer(c);
    });
  }
  function hasStamped(cart, vid) {
    return (cart.items || []).some(function (it) {
      return String(it.variant_id) === String(vid) && it.properties && it.properties._bundle_surface === 'cart';
    });
  }

  /* ---------- Add in place ---------- */
  var busy = {};
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-sco-add]');
    if (!b) return;
    e.preventDefault();
    var vid = b.getAttribute('data-sco-add');
    if (!vid || b.disabled || busy[vid]) return;
    busy[vid] = true;
    b.disabled = true; b.setAttribute('aria-busy', 'true');
    var keep = !!b.closest('#slideout-ajax-cart');
    var build = buildOf(b);
    var info = { anchor: b.getAttribute('data-sco-anchor'), build: build, row: b.getAttribute('data-sco-row'),
      variant_id: String(vid), product_id: String(b.getAttribute('data-sco-pid') || ''), surface: 'cart', arm: 'cart',
      gap: !!b.closest('[data-sco-gap]') };
    var props = { _bundle_anchor: info.anchor, _bundle_row: info.row, _bundle_surface: 'cart', _bundle_build: build };
    function done(ok) {
      if (ok) {
        pub('sofia_bundle_add', info);
        /* the refresh replaces this button; keep the guard until it has */
        setTimeout(function () { busy[vid] = false; }, 4000);
      } else {
        busy[vid] = false;
        if (document.contains(b)) { b.disabled = false; b.removeAttribute('aria-busy'); }
      }
      return redraw(keep).catch(function () {});
    }
    Q(function () {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1, properties: props }] }) })
        .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
    }).then(function () { return done(true); }, function () {
      /* the add may still have landed: re-read the cart before offering it again */
      return readCart().then(function (cart) { return done(hasStamped(cart, vid)); }, function () { return done(false); });
    });
  });

  /* ---------- Seen: once per page load per distinct offer set / drawer state, while on screen ---------- */
  var seen = {}, seenState = {};
  /* the cart container on screen: the open drawer, else the cart page's own form */
  function host() {
    var d = drawer();
    if (isOpen(d)) return { el: d, surface: 'drawer' };
    if (document.body && document.body.classList.contains('template-cart')) {
      var list = document.querySelectorAll('script[data-sco-state], [data-sco]');
      for (var i = 0; i < list.length; i++) {
        if (d && d.contains(list[i])) continue;
        var el = list[i].closest('.js-ajax-cart-content') || list[i].closest('form') || list[i].parentElement;
        return { el: el, surface: 'cart_page' };
      }
    }
    return null;
  }
  function look() {
    var h = host(); if (!h) return;
    var box = h.el.querySelector('[data-sco]');
    if (box) {
      var key = box.getAttribute('data-sco-key') || '';
      if (!seen[key]) {
        seen[key] = true;
        var rows = {};
        box.querySelectorAll('[data-sco-kind]').forEach(function (r) { var k = r.getAttribute('data-sco-kind'); rows[k] = (rows[k] || 0) + 1; });
        pub('sofia_bundle_view', { anchor: box.getAttribute('data-sco-anchor'), build: buildOf(box), surface: 'cart', arm: 'cart', rows: rows,
          gap: !!box.querySelector('[data-sco-gap]') });
      }
    }
    state(h);
  }
  function state(h) {
    var s = h.el.querySelector('script[data-sco-state]');
    var st = {};
    try { st = JSON.parse((s && s.textContent) || '{}'); } catch (e) { st = {}; }
    var cd = h.el.querySelector('.js-cart-shipping-countdown');
    var one = cd && cd.querySelector('[data-sofia-one]');
    var first = one || (cd && cd.querySelector('p'));
    var msg = first ? String(first.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 160) : null;
    var kind = one ? one.getAttribute('data-sofia-one') : (msg && /^pick up only/i.test(msg) ? 'pickup' : (cd ? 'classic' : 'none'));
    var data = { surface: h.surface, build: st.build || BUILD, message_kind: kind, message: msg,
      items: st.items == null ? null : st.items, subtotal: st.subtotal == null ? null : st.subtotal,
      goods: st.goods == null ? null : st.goods, gap: st.gap == null ? null : st.gap, gap_mode: !!st.gap_mode,
      free_card_on: !!st.free_card_on, free_card: !!st.free_card, has_card: !!st.has_card,
      palette: st.palette || null, offers: st.offers || [] };
    var key = JSON.stringify(data);
    if (seenState[key]) return; seenState[key] = true;
    pub('sofia_drawer_state', data);
  }
  var lookT;
  /* waits for the refresh that follows an add or an open, so a set shown for a split second is not counted */
  function soon() { clearTimeout(lookT); lookT = setTimeout(look, 700); }

  /* ---------- Removed: a drawer-added line taken out with x, or to 0 ---------- */
  var gone = {};
  function stamped(el) {
    var host = (el.closest && el.closest('.js-ajax-cart-content')) || document;
    var s = host.querySelector('script[data-sco-lines]');
    try { return JSON.parse((s && s.textContent) || '{}'); } catch (e) { return {}; }
  }
  function removed(el, key) {
    if (!key) return;
    var line = stamped(el)[key]; if (!line) return;
    var now = Date.now(); if (gone[key] && now - gone[key] < 2500) return; gone[key] = now;
    pub('sofia_bundle_remove', { anchor: line.anchor, build: line.build || BUILD, row: line.row,
      variant_id: String(line.variant_id), product_id: String(line.product_id), surface: 'cart', arm: 'cart' });
  }
  document.addEventListener('click', function (e) {
    var x = e.target && e.target.closest && e.target.closest('.js-cart-remove, [data-ajax-qty-decrease]');
    if (!x) return;
    if (x.hasAttribute('data-ajax-qty-decrease')) {
      var q = x.parentElement && x.parentElement.querySelector('[data-item-qty]');
      if (!q || parseInt(q.value, 10) !== 1) return;
    }
    removed(x, x.getAttribute('data-item-key'));
  }, true);
  document.addEventListener('change', function (e) {
    var q = e.target;
    if (!e.isTrusted || !q || !q.matches || !q.matches('[data-item-qty]')) return;
    if (parseInt(q.value, 10) === 0) removed(q, q.getAttribute('data-item-key'));
  }, true);

  /* ---------- Link markers (row 421 a) ---------- */
  function srcOf(a) {
    if (a.closest('#slideout-ajax-cart')) return 'drawer';
    if (a.closest('#main-nav, #mobile-drilldown')) return 'menu';
    if (a.matches('#gift-boxes a.shb-tile, .shb-all a.shb-all__tile, .shb-page a.shb-more__tile')) return 'giftbox';
    if (a.matches('.shb-page a.shb-piece__img, .shb-page a.shb-piece__name')) return 'giftbox_piece';
    if (a.closest('.footer-section')) return 'footer';
    return null;
  }
  function mark(e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var raw = a.getAttribute('href') || '';
    if (!raw || raw.charAt(0) === '#' || /^(mailto|tel|sms|javascript):/i.test(raw)) return;
    var src = srcOf(a); if (!src) return;
    try {
      var u = new URL(raw, location.href);
      if (u.origin !== location.origin) return;
      if (u.searchParams.get('_src') === src) return;
      u.searchParams.set('_src', src);
      a.setAttribute('href', u.pathname + u.search + u.hash);
    } catch (err) {}
  }
  document.addEventListener('pointerdown', mark, true);
  document.addEventListener('click', mark, true);
  document.addEventListener('auxclick', mark, true);

  /* ---------- Watch ---------- */
  function boot() {
    var d = drawer();
    if (d) {
      d.addEventListener('toggle', function (e) { if (!e.newState || e.newState === 'open') soon(); });
    }
    if ('MutationObserver' in window) {
      document.querySelectorAll('.js-ajax-cart-content').forEach(function (c) {
        if (c.__scoObs) return; c.__scoObs = true;
        new MutationObserver(soon).observe(c, { childList: true });
      });
    }
    soon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
